<template>
  <section>
    <el-divider>OR</el-divider>
    <el-button type="default" class="w-100" @click="azureSignIn">
    <i><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21"><title>MS-SymbolLockup</title><rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/></svg></i>
    Sign-in with Microsoft</el-button>
  </section>
</template>

<script>
export default {
  name: 'AzureLogin',
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  updated() {
  },
  activated() {
  },
    methods: {
    azureSignIn() {
            window.location = `/oauth2/azure/login`
        }
    }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
